// Paleta de colores de Visualize
export const COLORS = {
  // Colores principales
  primary: '#FF6B35',
  primaryDark: '#E55A2B',

  // Colores secundarios
  gray: '#575756',
  grayLight: '#666',

  // Colores de UI
  white: '#FFFFFF',
  black: '#000000',

  // Naranja neón
  neonOrange: '#FF6B35',
  neonOrangeLight: '#FF8C5A',
  neonOrangeDark: '#E55A2B',

  // Colores de estado
  error: '#FF0000',
  success: '#00FF00',

  // Overlays y transparencias
  overlayDark: 'rgba(0, 0, 0, 0.7)',
  overlayPrimary: 'rgba(255, 107, 53, 0.7)',

  // Backgrounds
  backgroundColor: '#000000',
  backgroundLight: '#FFFFFF',
};

export default COLORS;
